// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { shimmer as _shimmer } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the shimmer chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 148
 * Chain Name: Shimmer
 * Default Block Explorer: https://explorer.evm.shimmer.network
 * Default RPC URL: https://json-rpc.evm.shimmer.network
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { shimmer } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: shimmer,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const shimmer = createCommon({
	..._shimmer,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
